import {Action} from '@ngrx/store';
import {ArrayResponse, type} from '../../shared';
import { SalesStatistic } from '../models/sales-statistic';


export const salesStatisticListActionTypes = {
  LOAD: type('[Sales statistic list] Load'),
  LOAD_SUCCESS: type('[Sales statistic list] Load Success'),
  LOAD_FAIL: type('[Sales statistic list] Load Fail'),
};

export class LoadSalesStatisticListAction implements Action {
  readonly type = salesStatisticListActionTypes.LOAD;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class LoadSalesStatisticListSuccessAction implements Action {
  readonly type = salesStatisticListActionTypes.LOAD_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: ArrayResponse<SalesStatistic>) {}
}

export class LoadSalesStatisticListFailAction implements Action {
  readonly type = salesStatisticListActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
